const Tag = {
    getNames: function (data){
        let tag_names = [];
        data.edges.forEach(edge => {
            tag_names.push(edge.node.name);
        });
        return tag_names;
    }
};

export default Tag;
